import * as types from './actionTypes';

export const setDisplayIdAndGetTokensDataRequest = (displayId, confirmAction) => ({
    type: types.SET_DISPLAY_ID_AND_GET_TOKENS_DATA_REQUEST,
    payload: { displayId, confirmAction }
});

export const setDisplayIdAndGetTokensDataResponse = (displayBoardId, themeName, tokensData, differentialData, isLicenseActive, isDisplayBoardActive) => ({
    type: types.SET_DISPLAY_ID_AND_GET_TOKENS_DATA_RESPONSE,
    payload: { displayBoardId, themeName, tokensData, differentialData, isLicenseActive, isDisplayBoardActive }
});

export const setAlertDataRequest = tokenData => ({
    type: types.SET_ALERT_DATA_REQUEST,
    payload: tokenData
});

export const setAlertDataResponse = updatedTokensData => ({
    type: types.SET_ALERT_DATA_RESPONSE,
    payload: updatedTokensData
});

export const alertSuspend = () => ({
    type: types.ALERT_SUSPEND
});

export const setAlert = () => ({
    type: types.SET_ALERT
});
export const getTokensDataWithSocketRequest = (data) => ({
    type: types.GET_TOKENS_DATA_WITH_SOCKET_REQUEST,
    payload: data
});

export const socketInitate = () => ({
    type: types.SOCKET_INTIATE
});